(function () {
    'use strict';
    angular.module('app.fileupload', ['ngFileUpload']);
})();
